import type { FC } from 'react';

import styles from './EcommerceSearchOverlay.module.scss';
import { getEcommerceSearchOverlayResultsMessage } from './EcommerceSearchOverlay.utils';

interface EcommerceSearchOverlayResultsSummaryProps {
    queryUsed: string;
    totalResults: number;
}

const EcommerceSearchOverlayResultsSummary: FC<EcommerceSearchOverlayResultsSummaryProps> = ({
    queryUsed,
    totalResults,
}) => {
    return (
        <p className={styles.EcommerceSearchOverlayResultsSummary}>
            {getEcommerceSearchOverlayResultsMessage(queryUsed, totalResults)}
        </p>
    );
};

export default EcommerceSearchOverlayResultsSummary;
